import { render, staticRenderFns } from "./dettaglioCliente.html?vue&type=template&id=45355474&"
import script from "./DettaglioCliente.vue?vue&type=script&lang=js&"
export * from "./DettaglioCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports